import {
  SERVICE_CHANGE_VALUE,
  SERVICE_CHANGE_VALUES,
  SERVICE_CHANGE_CURRENT_SR,
  SERVICE_RESET_MODAL,
  SERVICE_ACTION_UPDATE,
  SERVICE_SET_LEAD_DETAIL,
  SERVICE_SET_ITEM,
} from '@shared/store/constants/mutationTypes';

const mutations = {
  [SERVICE_CHANGE_VALUE]: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    state[field] = value;
  },
  [SERVICE_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
  [SERVICE_CHANGE_CURRENT_SR]: (state, payload) => {
    const {
      field,
      value,
    } = payload;
    state.actionRequest[field] = value;
  },
  [SERVICE_SET_ITEM]: (state, payload) => {
    const {
      serviceInfo,
      serviceReference,
      bottomSheetView,
    } = payload;
    state.serviceInfo = serviceInfo;
    state.serviceReference = serviceReference;
    state.showServiceBottomSheet = true;
    state.serviceBottomsheetView = bottomSheetView;
  },
  [SERVICE_ACTION_UPDATE]: (state, payload) => {
    const {
      serviceRequestList,
      serviceInfo,
    } = state;
    const {
      updatedService,
    } = payload;

    const updatedServiceInfo = { ...serviceInfo, serviceRequest: { ...updatedService } };
    state.serviceInfo = updatedServiceInfo;
    state.serviceRequestList = serviceRequestList.map((item) => {
      if (item.requestId === updatedService.requestId) {
        return updatedServiceInfo;
      }
      return item;
    });
    state.showActionModal = false;
    state.actionModalView = '';
  },
  [SERVICE_SET_LEAD_DETAIL]: (state, payload) => {
    const {
      leadDetail,
      recentCycleList,
      activeAlertList,
      systemInsightList,
      loadingDetail,
    } = payload;

    state.leadDetail = leadDetail;
    state.recentCycleList = recentCycleList;
    state.activeAlertList = activeAlertList;
    state.systemInsightList = systemInsightList;
    state.loadingDetail = loadingDetail;
  },
  [SERVICE_RESET_MODAL]: (state) => {
    state.showActionModal = false;
    state.errorObj = {};
  },
};
export default mutations;
